import React, { Fragment, useState } from 'react';
import cn from 'classnames';
// import { parse } from 'date-fns';
import { formatDate } from '../../common/utils/format';
import { ProjectApi } from '../../customer_project/api/project-api';
import SvgIcon from '../../common/SvgIcon';
// import project from '../../design/routes/Workdesk/api/project';
import workInProgressImg from './work_in_progress.jpg';
import onboardingImg from './onboarding.png';
import {isRoomStyling} from "../../common/components/ProjectStatus/utils";

const PROJECT_ONBOARDING_STATUS = 'onboarding';
const PROJECT_ON_PAUSE_STATUS = 'on_pause';

const projectRedBorder = project =>
  project.status === PROJECT_ONBOARDING_STATUS || project.status === PROJECT_ON_PAUSE_STATUS;

const projectName = project => `${project.headline || project.name}`;

const projectArchivedForCustomer = project => project.status === 'archived';

const categoryReleasedForCustomer = project =>
  project.category_release_status === 'approved' && project.status === 'in_progress';

const projectInProgress = project =>
  project.status === 'in_progress' || project.status === 'awaiting' || project.status === 'sent_to_review';

const projectOnboarding = project => project.status === 'onboarding';

const isConsultancy = project => project.plan === 'consultancy';

const isRoomStylingProject = project => {
  return isRoomStyling(project.room_type);
};

const projectOnPause = project => project.status === 'on_pause';

const projectMoreTimeApproved = project => project.additional_hours_status === 'approved';

const projectRestartRequestDate = project => {
  if (!project.unpause_requested_at) return null;
  return formatDate(project.unpause_requested_at);
};

const projectMoreTimeRequestDate = project => {
  if (!project.additional_hours_requested_at) return null;
  return formatDate(project.additional_hours_requested_at);
};

const projectRestartRequested = project =>
  projectOnPause(project) && projectRestartRequestDate(project);

const projectMoreTimeRequested = project =>
  (projectArchived(project) || projectApproved(project)) && projectMoreTimeRequestDate(project);

const projectApproved = project => project.status === 'approved';
const projectArchived = project => project.status === 'archived';

const ProjectItem = ({ project: initProjects, proPlatform }) => {
  const [project, setProject] = useState(initProjects);
  const [actionInProgress, setActionInProgress] = useState(0);

  const roomStylingProject = isRoomStylingProject(project);
  function requestUnpauseOnClick() {
    setTimeout(() => setActionInProgress(actionInProgress + 1));
    ProjectApi.requestProjectRestart(
      project.id,
      response => {
        setTimeout(() => {
          setProject(response);
          setActionInProgress(actionInProgress - 1);
        }, 500);
        return response;
      },
      response => {
        alert('Sorry. Something went wrong.');
        setActionInProgress(actionInProgress - 1);
        return response;
      },
    );
  }

  function requestMoreTimeOnClick() {
    setTimeout(() => setActionInProgress(actionInProgress + 1));
    ProjectApi.requestProjectMoreTime(
      project.id,
      response => {
        setTimeout(() => {
          setProject(response);
          setActionInProgress(actionInProgress - 1);
        }, 500);
        return response;
      },
      response => {
        alert('Sorry. Something went wrong.');
        setActionInProgress(actionInProgress - 1);
        return response;
      },
    );
  }

  const renderProjectCompleted = () => (
    <div className="image -fourxthree">
      {project.image && <img className="image_body" src={project.image.url} alt="" />}
    </div>
  );

  const renderCategoryReleasedForCustomer = () => {
    const { image } = project;
    if (image && image.url) {
      return renderProjectCompleted();
    }
    return (
      <div className="image -fourxthree">
        <img className="image_body" src={workInProgressImg} alt=""/>
      </div>
    );
  };

  const renderProjectOnboarding = () => (
    <div className="image -fourxthree">
      <img className="image_body" src={onboardingImg} alt=""/>
    </div>
  );

  const renderProjectOnPause = () => (
    <div className="text-with-icon">
      <div className="text-with-icon_inner">
        <div className="status-icon">
          <svg className="">
            <use xlinkHref="#project-on-pause" xmlnsXlink="http://www.w3.org/1999/xlink" />
          </svg>
        </div>
      </div>
    </div>
  );

  const renderProjectInProgress = () => (
    <div className="image -fourxthree">
      <img className="image_body" src={workInProgressImg} alt="" />
    </div>
    // <div className="text-with-icon">
    //   <div className="text-with-icon_inner">
    //     <div className="status-icon">
    //       <svg className="">
    //           <use xlinkHref="#project-in-progress" xmlnsXlink="http://www.w3.org/1999/xlink" />
    //         </svg>
    //       </div>
    //       {/* <span className="project-preview-text">Design in progress</span> */}
    //     </div>
    //   </div>
  );

  const renderConsultanyProgress = () => {
    const { image } = project;
    return (
      <Fragment>
        {image && (
          <div className="image -fourxthree">
            {<img className="image_body" src={project.image.url} alt="" />}
          </div>
        )}
        {!image && (
          <div className="image -fourxthree">
            <img className="image_body" src={workInProgressImg} alt=""/>
          </div>
        )}
      </Fragment>
    );
  };

  const renderProjectImage = () => {
    if (isConsultancy(project)) {
      return renderConsultanyProgress(project);
    }
    if (projectOnPause(project)) {
      return renderProjectOnPause(project);
    }
    if (projectApproved(project)) {
      return renderProjectCompleted(project);
    }
    if (projectArchivedForCustomer(project)) {
      return renderProjectCompleted(project);
    }
    if (categoryReleasedForCustomer(project)) {
      return renderCategoryReleasedForCustomer(project);
    }
    if (projectOnboarding(project)) {
      return renderProjectOnboarding(project);
    }
    return renderProjectInProgress(project);
  };

  const renderConsultancyStatusDescription = () => {
    if (projectInProgress(project)) {
      if (!proPlatform && projectMoreTimeApproved(project)) {
        return (
          <div className="project-preview_attention">
            <div className="project-preview_attention_title">
              <SvgIcon icon="icon-more-hours" />
              Your design is ready - let the shopping begin! 🛍
            </div>
            <div>
              Benefit from our exclusive discounts of up to 25%.
              Have questions? You can reach your shopping support team on the chat anytime, and for as long as you need.
            </div>
            <div>
              Hours bought: {project.hours_purchased} <br />
              Hours complete: {project.hours_used}
            </div>
            <div className="project-preview_attention_button">
              <button type="button" className="btn -empty -with-icon">
                <SvgIcon icon="icon-check" className="checkbox_icon" />
                MORE TIME ADDED WITH YOUR DESIGNER
              </button>
            </div>
          </div>
        );
      }
      if (!proPlatform && !project.designer_assigned) {
        return (
          <div className="project-preview_attention">
            <div className="project-preview_attention_title">Brief complete - thank you!</div>
            <div>
              Our team will review the details and match your with a designer. We'll introduce your
              to your designer on the CHAT to start the design process.
            </div>
            <div>
              Hours bought: {project.hours_purchased} <br />
              Hours complete: {project.hours_used}
            </div>
          </div>
        );
      }

      return (
        <div className="project-preview_attention ">
          <div className="project-preview_attention_title">
            Design in progress: check in regularly to keep the design process moving.
          </div>
          <div> Your designer is working hard to create a room you'll love. </div>
          <div>
            Hours bought: {project.hours_purchased} <br />
            Hours complete: {project.hours_used}
          </div>
        </div>
      );
    }

    if (projectOnboarding(project)) {
      return (
        <div className="project-preview_attention -red">
          <div className="project-preview_attention_title">
            Action required: please complete the design brief.
          </div>
          <div>We need some additional to details to start the consultancy work.</div>
          <div className="project-preview_attention_button">
            <a href={project.link} className="btn -yellow">
              COMPLETE DESIGN BRIEF
            </a>
          </div>
        </div>
      );
    }

    if (projectApproved(project) || projectArchived(project)) {
      if (projectMoreTimeRequested(project)) {
        return (
          <div className="project-preview_attention">
            <div className="project-preview_attention_title">Consultancy complete!</div>
            <div>Your time has now come to and end with your designer.</div>
            <div className="project-preview_attention_button">
              <button type="button" className="btn -empty -with-icon">
                <SvgIcon icon="icon-check" className="checkbox_icon" />
                REQUEST SENT
              </button>
              <p>One of our team will be in touch shortly.</p>
            </div>
          </div>
        );
      }
      return (
        <div className="project-preview_attention">
          <div className="project-preview_attention_title">Consultancy complete!</div>
          <div>
            Your time has now come to and end with your designer. If you would like to buy more
            hours, please press the button below.
            <br />
            Hours bought: {project.hours_purchased} <br />
            Hours complete: {project.hours_used}
          </div>
          <div className="project-preview_attention_button">
            {!projectMoreTimeApproved(project) ? (
              <button
                onClick={() => requestMoreTimeOnClick()}
                type="button"
                className={cn('btn -yellow', { '-in-progress': actionInProgress })}
              >
                Buy more time with my designer
              </button>
            ) : null}
            {projectMoreTimeApproved(project) ? (
              <Fragment>
                <button type="button" className="btn -empty -with-icon">
                  <SvgIcon icon="icon-check" className="checkbox_icon" />
                  REQUEST SENT
                </button>
                <p>Thank you, one of our team will be in touch shortly.</p>
              </Fragment>
            ) : null}
          </div>
        </div>
      );
    }
    return null;
  };

  const projectReadySentance = () => {
    return roomStylingProject
      ? 'Shop your design with our exclusive discounts and our price match promise.'
      : "Enjoy built-in exclusive discounts and don’t forget, your £50 furniture credit will be automatically applied for every £1,000 you spend!"
  };

  const renderStatusDescription = () => {
    if (isConsultancy(project)) {
      return renderConsultancyStatusDescription(project);
    }

    if (projectOnboarding(project)) {
      return (
        <div className="project-preview_attention -red">
          <div className="project-preview_attention_title">
            Complete your design brief.
          </div>
          <div>
            We just need a few more details about you and your space so we can kick off the design process and start creating something amazing!
          </div>
          <div className="project-preview_attention_button">
            <a href={project.link} className="btn -yellow">
              Complete Design Brief
            </a>
          </div>
        </div>
      );
    };

    if (categoryReleasedForCustomer(project)) {
      return (
        <div className="project-preview_attention ">
          <div className="project-preview_attention_title">
            Categories released and ready to shop!
          </div>
          <div>
            Your designer is working hard to create a room you'll love. Please continue to check in
            regularly to keep the design process moving.
          </div>
        </div>
      );
    };

    if (projectInProgress(project)) {
      if (!proPlatform && projectMoreTimeApproved(project)) {
        return (
          <div className="project-preview_attention">
            <div className="project-preview_attention_title">
              <SvgIcon icon="icon-more-hours" />
              Your design is ready - let the shopping begin! 🛍️
            </div>
            <div>
              {projectReadySentance()}
            </div>
            <div>
              Got questions? Your shopping support team is just a message away - anytime you need.
            </div>
            <div className="project-preview_attention_button">
              <button type="button" className="btn -empty -with-icon">
                <SvgIcon icon="icon-check" className="checkbox_icon" />
                MORE TIME ADDED WITH YOUR DESIGNER
              </button>
            </div>
          </div>
        );
      }
      // if (!proPlatform && !project.designer_assigned) {
      //   return (
      //     <div className="project-preview_attention">
      //       <div className="project-preview_attention_title">Brief complete - thank you!</div>
      //       <div>
      //         Our team will review the details and match your with a designer. We'll introduce your
      //         to your designer on the CHAT to start the design process.
      //       </div>
      //     </div>
      //   );
      // }

      return (
        <div className="project-preview_attention ">
          <div className="project-preview_attention_title">
            Design in progress: check in regularly to keep the design process moving.
          </div>
          <div> Your designer is working hard to create a room you'll love. </div>
        </div>
      );
    }
    if (projectOnPause(project)) {
      if (projectRestartRequested(project)) {
        return (
          <div className="project-preview_attention">
            <div className="project-preview_attentiplease update the timeline as you go.on_title">
              <b>Design process on pause: request to restart project has been sent.</b>
              {/* <b> {formatDate(projectRestartRequestDate(project), FULL_HUMAN_DATE_FORMAT)} </b> */}
            </div>
            <div>Charges may apply if your brief has changed.</div>
            <div className="project-preview_attention_button">
              <button type="button" className="btn -empty -with-icon">
                <SvgIcon icon="icon-check" className="checkbox_icon" />
                Restart Requested
              </button>
              <p>One of our team will be in touch shortly.</p>
            </div>
          </div>
        );
      }

      return (
        <div className="project-preview_attention -red">
          <div className="project-preview_attention_title">
            Design paused: request to restart your project by clicking the button.
          </div>
          <div>Charges may apply if your original brief has changed.</div>
          <div className="project-preview_attention_button">
            <button
              onClick={() => requestUnpauseOnClick()}
              type="button"
              className={cn('btn -yellow', { '-in-progress': actionInProgress })}
            >
              Restart Project
            </button>
          </div>
        </div>
      );
    };

    if (projectApproved(project)) {
      return (
        <div className="project-preview_attention ">
          <div className="project-preview_attention_title">
            Your design is ready - let the shopping begin! 🛍️
          </div>
          {!proPlatform && (
            <Fragment>
              <div>
                {projectReadySentance()}
              </div>
              <div>
                Got questions? Your shopping support team is just a message away - anytime you need.
              </div>
              <div>
                Remember you have&nbsp;
                <b>{project.days_before_archived} days</b> to ask your designer any questions
              </div>
              <div className="project-preview_attention_button">
                <a href={project.link} className={cn('btn -yellow -in-progress')}>
                  Shop My Design
                </a>
              </div>
            </Fragment>
          )}
        </div>
      );
    };

    if (projectArchived(project)) {
      return (
        <div className="project-preview_attention">
          <div className="project-preview_attention_title">
            Your design is ready - let the shopping begin! 🛍️
          </div>
          {!proPlatform && (
            <Fragment>
              <div>
                {projectReadySentance()}
              </div>
              <div>
                Got questions? Your shopping support team is just a message away - anytime you need.
              </div>
              <div className="project-preview_attention_button">
                <a href={project.link} className={cn('btn -yellow -in-progress')}>
                  Shop My Design
                </a>
              </div>
            </Fragment>
          )}
        </div>
      );
    }
    return null;
  };

  const renderShareOptions = () => {
    if (!projectApproved(project) || proPlatform || isConsultancy(project)) return null;
    return (
      <div className="project-preview_attention">
        <div className="project-preview_attention_title">
          Share your design with family and friends
        </div>
        <div>
          Chuffed with your design and want to share it?
          Choose your method below and we'll create a copy to share!
          We'll even throw in a referral code for them to get 15% off their first room.
          When they book you'll also get 15% off you next room design!
        </div>
        <button type='button'>
          Copy link to design
        </button>
      </div>
    );
  };

  const renderProjectItem = () => (
    <div className={cn('customer-projects-list_item')}>
      <a href={project.link} className={cn('project-preview_image')}>
        <div className="project-preview_title -ontop text-center ">{projectName(project)}</div>
        <div
          className={cn('project-preview_photo-wrapper', {
            '-border-red': projectRedBorder(project),
          })}
        >
          {renderProjectImage(project)}
        </div>
        <div className="project-preview_title -under text-center">{projectName(project)}</div>
      </a>
      <div className="project-preview_info-wrapper">
        {renderStatusDescription(project)}
      </div>
    </div>
  );

  return renderProjectItem();
};

export default ProjectItem;



// WEBPACK FOOTER //
// ./app/javascript/components/customer_projects_list/project_item.js